export const FETCH_SHIPMENT_COUNT_SUCCESS = "FETCH_SHIPMENT_COUNT_SUCCESS";
export const FETCH_SHIPMENT_COUNT_REQUEST = "FETCH_SHIPMENT_COUNT_REQUEST";
export const FETCH_SHIPMENT_COUNT_FAILURE = "FETCH_SHIPMENT_COUNT_FAILURE";
export const FETCH_SHIPMENT_COUNT_REST = "FETCH_SHIPMENT_COUNT_REST";
export const fetchShipmentCountSuccess = (payload) => ({
    type: FETCH_SHIPMENT_COUNT_SUCCESS,
    payload,
});
export const fetchShipmentCountRequest = (payload) => ({
    type: FETCH_SHIPMENT_COUNT_REQUEST,
    payload,
});
export const fetchShipmentCountFailure = (payload) => ({
    type: FETCH_SHIPMENT_COUNT_FAILURE,
    payload,
});
export const fetchShipmentCountRest = () => ({
    type: FETCH_SHIPMENT_COUNT_REST,
});
